<rid-sentence-reading-base
  [title]="'Zinlezen'"
  [sentencesMatrix]="sentencesMatrix()"
  [pace]="pace()"
  [doSentencePass]="doSentencePass.bind(this)"
  (finished)="finished.emit()"
/>
